/*
 * @Description:
 * @Author: cooky
 * @Date: 2021-03-05 14:06:08
 * @LastEditors: cooky
 * @LastEditTime: 2021-03-16 10:42:14
 */

export function setUid (uid) {
  window.localStorage._uid = uid
}

export function getUid () {
  return window.localStorage._uid
}

export function parseQueryString (queryString) {
  const regExp = /(.+?)=([^&]+)&?/g
  const queryObj = {}
  let matchArr
  while ((matchArr = regExp.exec(queryString)) !== null) {
    const key = matchArr[1]
    const value = matchArr[2]
    queryObj[key] = value
  }
  return queryObj
}
// 生成唯一标识符
export function uuid () {
  const s = []
  const hexDigits = '0123456789a'
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  // s[8] = s[13] = s[18] = s[23] = '-'

  const uuid = s.join('').slice(0, 16)
  return uuid
}
